import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (reduced.matches) {
      return undefined;
    }

    let rafId;
    let lenis;
    let cancelled = false;

    import("lenis")
      .then(({ default: Lenis }) => {
        if (cancelled) return;
        lenis = new Lenis({
          duration: 1.15,
          lerp: 0.075,
          smoothWheel: true,
          wheelMultiplier: 0.92,
          touchMultiplier: 1.15,
        });
        window.lenis = lenis;
        lenis.on("scroll", ScrollTrigger.update);

        const raf = (time) => {
          lenis.raf(time);
          rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        document.documentElement.classList.add("lenis");
      })
      .catch(() => {
        window.lenis = undefined;
      });

    return () => {
      cancelled = true;
      cancelAnimationFrame(rafId);
      document.documentElement.classList.remove("lenis");
      window.lenis = undefined;
      lenis?.destroy();
    };
  }, []);

  return children;
};

export default SmoothScroll;
